__turbopack_context__.v({
  "container": "mochi-date-picker-module-scss-module__MQ-dgW__container",
  "dark-mode": "mochi-date-picker-module-scss-module__MQ-dgW__dark-mode",
  "error-message": "mochi-date-picker-module-scss-module__MQ-dgW__error-message",
  "invalid": "mochi-date-picker-module-scss-module__MQ-dgW__invalid",
  "light-mode": "mochi-date-picker-module-scss-module__MQ-dgW__light-mode",
  "normal": "mochi-date-picker-module-scss-module__MQ-dgW__normal",
  "placeholder": "mochi-date-picker-module-scss-module__MQ-dgW__placeholder",
  "round": "mochi-date-picker-module-scss-module__MQ-dgW__round",
  "selecting": "mochi-date-picker-module-scss-module__MQ-dgW__selecting",
});
